<template>
  <div
    class="d-flex align-items-center cursor-pointer"
    style="margin-bottom:7px;"
    @click="handleItemClick"
  >
    <span
      class="text-secondary"
      style="margin-right:5px;"
    >
      <GjIcon
        name="Minus"
        size="15"
      />
    </span>
    <span
      class="mr-1"
      :class="displayingItemUri === segment.uri ? 'text-thick' : ''"
    >
      {{ segment.uri }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'Segment',
  props: {
    displayingItemUri: {
      type: String,
      default: null,
    },
    segment: {
      type: Object,
      default: null,
      required: true,
    },
  },
  methods: {
    handleItemClick() {
      this.$emit('display', this.segment)
    },
  },
}
</script>

<style>

</style>
